<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Sco.Barcode.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Sco.Barcode.msg2') }}</div>
        <div class="ft-point">{{ $t('Modal.Sco.Barcode.msg3') }}</div>
      </div>
      <div class="layer__body mg-sm">
        <div class="flex-row">
          <div class="input-area">
            <label for="">{{ $t('Modal.Sco.Barcode.msg4') }}</label>
            <input type="text" maxlength="20" :placeholder="$t('Modal.Sco.Barcode.msg5')" :value="barcodeData" />
          </div>
          <div class="lyr-right">
            <div class="keypad">
              <button @mouseup="setBarcode(1)">1</button>
              <button @mouseup="setBarcode(2)">2</button>
              <button @mouseup="setBarcode(3)">3</button>
              <button @mouseup="setBarcode(4)">4</button>
              <button @mouseup="setBarcode(5)">5</button>
              <button @mouseup="setBarcode(6)">6</button>
              <button @mouseup="setBarcode(7)">7</button>
              <button @mouseup="setBarcode(8)">8</button>
              <button @mouseup="setBarcode(9)">9</button>
              <button @mouseup="setBarcode(10)" class="delete">{{ $t('Modal.Sco.Barcode.msg6') }}</button>
              <button @mouseup="setBarcode(0)">0</button>
              <button @mouseup="setBarcode(-1)" class="btn-back">{{ $t('Modal.Sco.Barcode.msg7') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('closeBarcode')">{{ $t('Modal.Sco.Barcode.msg8') }}</button>
        <button
          class="btn btn--submit"
          @mouseup="$emit('setBarcode', barcodeData)"
          :disabled="barcodeData.length < 3"
          :class="[barcodeData.length < 3 ? 'btn--disabled' : 'btn--color']"
        >
          {{ $t('Modal.Sco.Barcode.msg9') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'barcode',
  data() {
    return {
      barcodeData: '',
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {},
  methods: {
    setBarcode(num) {
      if (num == 10) this.barcodeData = '';
      else if (num < 0) this.barcodeData = this.barcodeData.slice(0, -1);
      else if (this.barcodeData.length < 20) this.barcodeData += num + '';
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/keypad.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/keypad-dark.css" scoped></style>
<style scoped>
@media (-webkit-device-pixel-ratio: 1.25) {
  .ft-point {
    font-size: 1.2em !important;
  }
}
.lyr-right {
  width: 50%;
  margin: 0 auto;
}
</style>
